module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-stone-path-background-remnants.dd346c11.png";